import { getAllCampaignTemplates } from "@/api/campaign-templates/get-all-campaign-templates";
import { getCampaignTemplateById } from "@/api/campaign-templates/get-campaign-template-by-id";
import { ICampaignTemplate } from "@/interfaces/campaign-template.interfaces";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class CampaignTemplateService {
  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<ICampaignTemplate>> {
    try {
      const response = await getAllCampaignTemplates();

      // Convert to expected format with proper mapping
      const mappedItems: ICampaignTemplate[] = response.data.map((template) => ({
        id: template.id,
        campaignId: 0, // Default value - will be set when template is used
        name: template.name,
        variables: {
          name: template.name,
          language: { code: "PT-BR" },
          components: [],
        },
        text: template.template || "",
        rowDate: template.createdAt,
      }));

      return {
        items: mappedItems,
        totalCount: response.totalCount,
        pageNumber: pagination.pageNumber,
        pageSize: pagination.pageSize,
        hasNextPage: response.totalCount > pagination.pageNumber * pagination.pageSize,
        hasPreviousPage: pagination.pageNumber > 1,
      };
    } catch (error) {
      // Fallback para dados mock quando API falha
      const mockTemplates: ICampaignTemplate[] = [
        {
          id: 1,
          campaignId: 0,
          name: "Template Cupom de Desconto",
          variables: {
            name: "Template Cupom de Desconto",
            language: { code: "PT-BR" },
            components: [],
          },
          text: "Olá!\n\nUse o código #CAMPAIGNCODE# para obter #DISCOUNT#% de desconto adicional em toda a sua compra.",
          rowDate: new Date().toISOString(),
        },
        {
          id: 2,
          campaignId: 0,
          name: "Template Preço Promocional",
          variables: {
            name: "Template Preço Promocional",
            language: { code: "PT-BR" },
            components: [],
          },
          text: "Olá!\n\nUse o código #CAMPAIGNCODE# e acesse o desconto para os produtos desta campanha.",
          rowDate: new Date().toISOString(),
        },
      ];

      return {
        items: mockTemplates,
        totalCount: mockTemplates.length,
        pageNumber: pagination.pageNumber,
        pageSize: pagination.pageSize,
        hasNextPage: false,
        hasPreviousPage: false,
      };
    }
  }

  async getById(templateId: number): Promise<ICampaignTemplate> {
    const response = await getCampaignTemplateById(templateId);

    // Convert to expected format
    return {
      id: response.id,
      campaignId: 0, // Default value - will be set when template is used
      name: response.name,
      variables: {
        name: response.name,
        language: { code: "PT-BR" },
        components: [],
      },
      text: response.template || "",
      rowDate: response.createdAt,
    };
  }
}

const campaignTemplateService = new CampaignTemplateService();
export default campaignTemplateService;
